import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch { setSent(true); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="forgot-password-page">
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 p-8">
        <Link to="/login" className="text-sm text-slate-400 hover:text-slate-600 flex items-center gap-1 mb-4"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
        {sent ? (
          <div className="text-center">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-emerald-500 flex items-center justify-center"><CheckCircle2 className="h-7 w-7 text-white" /></div>
            <h1 className="font-heading text-2xl font-bold mt-4">Check your inbox</h1>
            <p className="text-slate-500 mt-2">If an account exists for <span className="font-semibold">{email}</span>, we've sent a password reset link.</p>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold">Reset your password</h1>
            <p className="text-slate-500 mt-1 text-sm">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-5 space-y-3">
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.com" className="pl-9" />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700 gap-2">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Send reset link
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
